import FinalFormField from 'common/components/final-form/FinalFormField';
import useCodeTable from 'common/hooks/useCodeTable';
import DisplayAddress from 'domain/components/address/DisplayAddress';
import DraftApplication from 'domain/types/DraftApplication';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';

interface IRelationship {
  data: DraftApplication;
  showErrors: boolean;
  proof: React.ReactNode;
}

const Relationship = (props: IRelationship) => {
  const options = useCodeTable({
    endpoint: '/propertyRelationshipTypes',
  });

  return (
    <>
      <FormGroup as={Row}>
        <Col sm={{ span: 6 }} className='align-self-center'>
          <FormLabel>What is your relationship to the property: *</FormLabel>
          <div className='mb-3'>
            <DisplayAddress address={props.data.address} />
          </div>
          <FinalFormField
            type='select'
            name='propertyRelaCd'
            label={null}
            options={options}
          />
        </Col>
      </FormGroup>
      <FormGroup as={Row} className='flex-nowrap'>
        <Col sm={{ span: 6 }} className='align-self-center'>
          <FinalFormField
            type='select'
            name='primaryResIndicator'
            label='Do you live in this unit as your primary residence? *'
            text='Primary residence is based on the unit, not the building. You must live in the unit for at least 245 days out of the calendar year.'
            options={[
              { cd: '', descr: '--' },
              { cd: 'Y', descr: 'Yes' },
              { cd: 'N', descr: 'No' },
            ]}
          />
        </Col>
      </FormGroup>
      {props.data.primaryResIndicator === 'Y' && props.proof}
      <FormGroup as={Row}>
        <Col sm={{ span: 6 }} className='align-self-center'>
          <FinalFormField
            type='number'
            name='numberOfRooms'
            label='Shared housing units can have a maximum of 6 sleeping rooms. How many sleeping rooms are in your unit?'
          />
        </Col>
      </FormGroup>
    </>
  );
};

export default Relationship;
